import { errorTypes } from '../constants'

export const variableDenotationChar = '{{'

export const descriptionErrorMessages = {
  [errorTypes.descriptionEmpty]: 'Este campo es obligatorio',
  [errorTypes.descriptionTooLong]: 'Máximo 150 caracteres',
}
